import React from "react"
import PropTypes from "prop-types"
import PhoneNumberIcon from "../../assets/phone-number.inline.svg"
import EmailIcon from "../../assets/email.inline.svg"
import AddressIcon from "../../assets/address.inline.svg"

import styles from "./PointContent.module.scss"

const PointContent = ({ data }) => {
  return (
    <div>
      <h3 className={styles.title}>{data.title}</h3>
      <div className={styles.recyclingType}>{data.recyclingType.title}</div>
      <div>
        {!!data.phone && (
          <a className={styles.contactItem} href={`tel:${data.phone}`}>
            <PhoneNumberIcon /> {data.phone}
          </a>
        )}
        <a className={styles.contactItem} href={`mailto:${data.email}`}>
          <EmailIcon /> {data.email}
        </a>
        <div className={styles.contactItem}>
          <AddressIcon /> {data.fullAddress}
        </div>
      </div>
    </div>
  )
}

PointContent.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    fullAddress: PropTypes.string,
    promotions: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      })
    ),
    city: PropTypes.string,
    coordinates: PropTypes.arrayOf(PropTypes.number),
  }),
}

export default PointContent
